import React, { Component } from 'react'
import PropTypes from 'prop-types'

import MainButton from '../buttons/MainButton'
import MainButtonGroup from '../buttons/MainButtonGroup'

class ActivatedDeviceModal extends Component {
  render() {
    const { handleConfirmed, pin, applicationId } = this.props

    return (
      <div>
        <div className="reactivation-container">
          <div className="reactivation-row">
            <span className="reactivation-label">
              Application ID
            </span>
            <span className="reactivation-value">
              { applicationId }
            </span>
          </div>
          <div className="reactivation-row">
            <span className="reactivation-label">
              Access Key
            </span>
            <span className="reactivation-value pin">
              { pin }
            </span>
          </div>
        </div>
        <MainButtonGroup>
          <MainButton
            label="CONFIRM"
            buttonClass="blue"
            handleClick={ this._onConfirm(handleConfirmed) }
            id="button-confirm" />
        </MainButtonGroup>
      </div>
    )
  }

  _onConfirm = callback => () => {
    try {
      callback()
    } catch (e) {
      console.log(e) // eslint-disable-line no-console
    }
  }
}

ActivatedDeviceModal.propTypes = {
  pin: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  handleConfirmed: PropTypes.func.isRequired,
}

export default ActivatedDeviceModal
